<template>
	<v-row align-content="center" justify="center">
		<v-col md="8" cols="12">

			<form ref="form" @submit.prevent="onSubmit">
				<c-card color="#85afff">
					<h4 slot="title">
						<v-icon>mdi-ruler</v-icon>
						הזמנת מדידה - {{ client.name }}
					</h4>
					<div slot="bar-actions">
						<v-img width="100" src="/img/cadnet.jpeg"></v-img>
					</div>
					<v-card>
						<v-card-text>
							<h5>לקוח יקר,</h5>
							<p>
								<span>תודה שבחרת ב</span>
								<strong>קאדנט מדידות ממוחשבות </strong>
								<span>לבצע עבורך מדידה של חברת </span>
								<strong>{{ client.name }}</strong>
							</p>
						</v-card-text>
					</v-card>
					<v-card>
						<v-row align-content="center" justify="center">
							<v-col cols="12" md="4" align-self="center">
								<v-select
									label="שם החנות שרכשת"
									item-text="text"
									item-value="value"
									required
									:rules="[(v) => !!v || 'זהו שדה חובה']"

									v-model="form.project.branch_id"
									:items="branches"/>
							</v-col>
						</v-row>
					</v-card>
					<c-card>
						<h3 slot="title" color="green">{{ $t("pages.orderForm.customerDetails") }}</h3>
						<cols-row md="4">
							<smart-input required :error="inputErrors.customer" :label="$t('attributes.customerName')"
								v-model="form.customer"></smart-input>
							<smart-input required v-mask="'#########'" :error="inputErrors.id_number" label="תעודת זהות"
								v-model="form.id_number"></smart-input>
							<smart-input type="email" required :error="inputErrors.email" label="דואר אלקטרוני"
								v-model="form.email"></smart-input>
						</cols-row>
						<cols-row md="6">
							<smart-input type="phone" required :error="inputErrors.customer_phone" :label="$t('pages.orderTable.tel')"
								v-model="form.customer_phone" v-mask="phoneMask" :pattern="phonePattern"
								placeholder="05x-xxxxxxx or 0x-xxxxxxx"></smart-input>

							<smart-input :error="inputErrors.note" :label="$t('pages.projectForm.contact')"
								v-model="form.contact_name"></smart-input>
						</cols-row>
						<cols-row md="6" cols="12">
							<smart-input  type="phone" :error="inputErrors.tel2"  v-mask="phoneMask" :label="$t('pages.orderTable.tel2')"
								v-model="form.tel2" :pattern="phonePattern"
								placeholder="05x-xxxxxxx or 0x-xxxxxxx"></smart-input>
							<smart-input :error="inputErrors.contact_tel2"
								:label="$t('pages.orderConsForm.secondContact')"
								v-model="form.contact2_tel"
							></smart-input>
							<smart-input required :error="inputErrors.address" :label="$t('pages.orderForm.measurementAddress')"
								v-model="form.project.address"></smart-input>
							<cites-select v-model="form.project.city" required/>
							<smart-input required :error="inputErrors.building" :label="$t('pages.orderForm.building')"
								v-model="form.building"></smart-input>
							<smart-input :error="inputErrors.entrance" :label="$t('pages.orderForm.entrance')"
								v-model="form.entrance"></smart-input>
							<smart-input :error="inputErrors.apartment_floor" required :label="$t('pages.orderForm.floor')"
								v-model="form.apartment_floor"></smart-input>
							<smart-input required :error="inputErrors.apartment_num" :label="$t('pages.orderForm.apartmentNum')"
								v-model="form.apartment_num"></smart-input>
						</cols-row>
					</c-card>
					<c-card>
						<h3 slot="title" color="green">{{ $t("pages.orderForm.mesurementDetails") }}</h3>
						<measurement-form @remove="removeMeasurement(m)" :removedFiles="[]" :measurement="m"
							v-for="m in measurements"
							:key="m.id"/>
						<v-btn class="primary" text @click="addMeasurement()">
							<v-icon circle>add</v-icon>
							{{ $t("pages.orderForm.anotherOrder") }}
						</v-btn>
					</c-card>
					<cols-row cols="6" :row="{justify:'center'}">
						<btn-loader :progress="inProgress">שמירה</btn-loader>
					</cols-row>
					<!--      <v-card>{{client}}</v-card>-->
				</c-card>
			</form>
		</v-col>
	</v-row>
</template>

<script>
	import CCard from "dev/scaffoldings/cCard";
	import {types} from "dev/store/modules/OutsideModule";
	import CitesSelect from "dev/view/measurements/CitesSelect";
	import uniqueId from "lodash/uniqueId";
	import MeasurementForm from "dev/view/measurements/MeasurementForm";
	import BtnLoader from "dev/components/BtnLoader";

	export default {
		name: "out-side-view",
		components: {BtnLoader, MeasurementForm, CitesSelect, CCard},
		data() {
			return {
				phonePattern: "^[0-9]{2,3}-[0-9]{7}",
				form: {
					project: {
						branch_id:null
					}
				},
				measurements: [],
				inputErrors: {},
				inProgress: false,
				measurementsWithFiles: []
			};
		},
		methods: {
			phoneMask(value){
				if (value[1]==5){
					return [/[0]/,/[1-9]/,/[0-9]/,"-",/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,];
				}
				return [/[0]/,/[1-9]/,"-",/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,];
				return this.phonePattern;
			},
			async onSubmit() {
				this.inProgress = true;
				const formData = new FormData(this.$refs.form);
				const form = Object.assign({}, this.form, {measurements: this.measurements});
				formData.append("order", JSON.stringify(form));
				this.measurements.forEach(measurement => {
					if (measurement.files) {
						measurement.files.forEach((f, x) => {
							if (!f.id) {
								formData.append(`files-${measurement.id}[]`, f);
							}
						});
					}
				});
				try {
					const order = await this.$store.dispatch(types.SAVE, {clientId: this.$route.params.id, form:formData});
					this.$router.push({name:"outside.thank",params:{uuid:order.uuid}});
				} catch (e) {
				}
				this.inProgress = false;

			},
			removeMeasurement(m) {
				let index = this.measurements.indexOf(m);
				if (index > -1) {
					this.measurements.splice(index, 1);
				}
			},
			addMeasurement() {
				this.measurements.push({
					id: uniqueId("notreal"),
					files: []
				});
			},
			removedFIles() {

			}
		},
		computed: {
			client() {
				return this.$store.state.OutsideModule.client;
			},
			branches() {
				return this.client.branches;
			}
		},
		async created() {
			await this.$store.dispatch(types.GET, this.$route.params.id);
			if (this.branches.length === 1) {
				this.form.project.branch_id = this.branches.at(0).value;
			}
			this.addMeasurement();
		}
	};
</script>

<style scoped>

</style>
